/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthSocialRouteImport } from './routes/auth/social'
import { Route as OauthAuthorizeRouteImport } from './routes/oauth/authorize'
import { Route as AppCommunityIndexRouteImport } from './routes/_app/community/index'
import { Route as AppCommunityComposeRouteImport } from './routes/_app/community/compose'
import { Route as AppCommunitySearchRouteImport } from './routes/_app/community/search'
import { Route as AppExercisesIndexRouteImport } from './routes/_app/exercises/index'
import { Route as AppExercisesIdRouteImport } from './routes/_app/exercises/$id'
import { Route as AppExercisesNewRouteImport } from './routes/_app/exercises/new'
import { Route as AppFoodIndexRouteImport } from './routes/_app/food/index'
import { Route as AppFoodAddRouteImport } from './routes/_app/food/add'
import { Route as AppFoodScanRouteImport } from './routes/_app/food/scan'
import { Route as AppFoodTargetsRouteImport } from './routes/_app/food/targets'
import { Route as AppFoodTrendsRouteImport } from './routes/_app/food/trends'
import { Route as AppProgressIndexRouteImport } from './routes/_app/progress/index'
import { Route as AppRoutinesIndexRouteImport } from './routes/_app/routines/index'
import { Route as AppRoutinesNewRouteImport } from './routes/_app/routines/new'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAccountRouteImport } from './routes/_app/settings/account'
import { Route as AppSettingsBlocksRouteImport } from './routes/_app/settings/blocks'
import { Route as AppSettingsGuideRouteImport } from './routes/_app/settings/guide'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppSettingsTokensRouteImport } from './routes/_app/settings/tokens'
import { Route as AppTrainIndexRouteImport } from './routes/_app/train/index'
import { Route as AppFoodFoodsIdRouteImport } from './routes/_app/food/foods/$id'
import { Route as AppFoodFoodsNewRouteImport } from './routes/_app/food/foods/new'
import { Route as AppFoodRecipesIndexRouteImport } from './routes/_app/food/recipes/index'
import { Route as AppFoodRecipesNewRouteImport } from './routes/_app/food/recipes/new'
import { Route as AppProgressExercisesExerciseIdRouteImport } from './routes/_app/progress/exercises/$exerciseId'
import { Route as AppRoutinesIdIndexRouteImport } from './routes/_app/routines/$id/index'
import { Route as AppRoutinesIdEditRouteImport } from './routes/_app/routines/$id/edit'
import { Route as AppRoutinesTemplatesIdRouteImport } from './routes/_app/routines/templates/$id'
import { Route as AppTrainHistoryIndexRouteImport } from './routes/_app/train/history/index'
import { Route as AppTrainHistoryClientIdRouteImport } from './routes/_app/train/history/$clientId'
import { Route as AppTrainSessionClientIdRouteImport } from './routes/_app/train/session/$clientId'
import { Route as AppTrainSessionNewRouteImport } from './routes/_app/train/session/new'
import { Route as AppCommunityUHandleIndexRouteImport } from './routes/_app/community/u/$handle/index'
import { Route as AppCommunityUHandleFollowersRouteImport } from './routes/_app/community/u/$handle/followers'
import { Route as AppCommunityUHandleFollowingRouteImport } from './routes/_app/community/u/$handle/following'
import { Route as AppFoodRecipesIdIndexRouteImport } from './routes/_app/food/recipes/$id/index'
import { Route as AppFoodRecipesIdEditRouteImport } from './routes/_app/food/recipes/$id/edit'
import { Route as AppTrainDayRoutineIdDayIdRouteImport } from './routes/_app/train/day/$routineId/$dayId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthSocialRoute = AuthSocialRouteImport.update({
  id: '/auth/social',
  path: '/auth/social',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthAuthorizeRoute = OauthAuthorizeRouteImport.update({
  id: '/oauth/authorize',
  path: '/oauth/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCommunityIndexRoute = AppCommunityIndexRouteImport.update({
  id: '/community/',
  path: '/community/',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunityComposeRoute = AppCommunityComposeRouteImport.update({
  id: '/community/compose',
  path: '/community/compose',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunitySearchRoute = AppCommunitySearchRouteImport.update({
  id: '/community/search',
  path: '/community/search',
  getParentRoute: () => AppRoute,
} as any)
const AppExercisesIndexRoute = AppExercisesIndexRouteImport.update({
  id: '/exercises/',
  path: '/exercises/',
  getParentRoute: () => AppRoute,
} as any)
const AppExercisesIdRoute = AppExercisesIdRouteImport.update({
  id: '/exercises/$id',
  path: '/exercises/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppExercisesNewRoute = AppExercisesNewRouteImport.update({
  id: '/exercises/new',
  path: '/exercises/new',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodIndexRoute = AppFoodIndexRouteImport.update({
  id: '/food/',
  path: '/food/',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodAddRoute = AppFoodAddRouteImport.update({
  id: '/food/add',
  path: '/food/add',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodScanRoute = AppFoodScanRouteImport.update({
  id: '/food/scan',
  path: '/food/scan',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodTargetsRoute = AppFoodTargetsRouteImport.update({
  id: '/food/targets',
  path: '/food/targets',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodTrendsRoute = AppFoodTrendsRouteImport.update({
  id: '/food/trends',
  path: '/food/trends',
  getParentRoute: () => AppRoute,
} as any)
const AppProgressIndexRoute = AppProgressIndexRouteImport.update({
  id: '/progress/',
  path: '/progress/',
  getParentRoute: () => AppRoute,
} as any)
const AppRoutinesIndexRoute = AppRoutinesIndexRouteImport.update({
  id: '/routines/',
  path: '/routines/',
  getParentRoute: () => AppRoute,
} as any)
const AppRoutinesNewRoute = AppRoutinesNewRouteImport.update({
  id: '/routines/new',
  path: '/routines/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAccountRoute = AppSettingsAccountRouteImport.update({
  id: '/settings/account',
  path: '/settings/account',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsBlocksRoute = AppSettingsBlocksRouteImport.update({
  id: '/settings/blocks',
  path: '/settings/blocks',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGuideRoute = AppSettingsGuideRouteImport.update({
  id: '/settings/guide',
  path: '/settings/guide',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsTokensRoute = AppSettingsTokensRouteImport.update({
  id: '/settings/tokens',
  path: '/settings/tokens',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainIndexRoute = AppTrainIndexRouteImport.update({
  id: '/train/',
  path: '/train/',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodFoodsIdRoute = AppFoodFoodsIdRouteImport.update({
  id: '/food/foods/$id',
  path: '/food/foods/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodFoodsNewRoute = AppFoodFoodsNewRouteImport.update({
  id: '/food/foods/new',
  path: '/food/foods/new',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodRecipesIndexRoute = AppFoodRecipesIndexRouteImport.update({
  id: '/food/recipes/',
  path: '/food/recipes/',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodRecipesNewRoute = AppFoodRecipesNewRouteImport.update({
  id: '/food/recipes/new',
  path: '/food/recipes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProgressExercisesExerciseIdRoute =
  AppProgressExercisesExerciseIdRouteImport.update({
    id: '/progress/exercises/$exerciseId',
    path: '/progress/exercises/$exerciseId',
    getParentRoute: () => AppRoute,
  } as any)
const AppRoutinesIdIndexRoute = AppRoutinesIdIndexRouteImport.update({
  id: '/routines/$id/',
  path: '/routines/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppRoutinesIdEditRoute = AppRoutinesIdEditRouteImport.update({
  id: '/routines/$id/edit',
  path: '/routines/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppRoutinesTemplatesIdRoute = AppRoutinesTemplatesIdRouteImport.update({
  id: '/routines/templates/$id',
  path: '/routines/templates/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainHistoryIndexRoute = AppTrainHistoryIndexRouteImport.update({
  id: '/train/history/',
  path: '/train/history/',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainHistoryClientIdRoute = AppTrainHistoryClientIdRouteImport.update({
  id: '/train/history/$clientId',
  path: '/train/history/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainSessionClientIdRoute = AppTrainSessionClientIdRouteImport.update({
  id: '/train/session/$clientId',
  path: '/train/session/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainSessionNewRoute = AppTrainSessionNewRouteImport.update({
  id: '/train/session/new',
  path: '/train/session/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunityUHandleIndexRoute =
  AppCommunityUHandleIndexRouteImport.update({
    id: '/community/u/$handle/',
    path: '/community/u/$handle/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCommunityUHandleFollowersRoute =
  AppCommunityUHandleFollowersRouteImport.update({
    id: '/community/u/$handle/followers',
    path: '/community/u/$handle/followers',
    getParentRoute: () => AppRoute,
  } as any)
const AppCommunityUHandleFollowingRoute =
  AppCommunityUHandleFollowingRouteImport.update({
    id: '/community/u/$handle/following',
    path: '/community/u/$handle/following',
    getParentRoute: () => AppRoute,
  } as any)
const AppFoodRecipesIdIndexRoute = AppFoodRecipesIdIndexRouteImport.update({
  id: '/food/recipes/$id/',
  path: '/food/recipes/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppFoodRecipesIdEditRoute = AppFoodRecipesIdEditRouteImport.update({
  id: '/food/recipes/$id/edit',
  path: '/food/recipes/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppTrainDayRoutineIdDayIdRoute =
  AppTrainDayRoutineIdDayIdRouteImport.update({
    id: '/train/day/$routineId/$dayId',
    path: '/train/day/$routineId/$dayId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/auth/social': typeof AuthSocialRoute
  '/oauth/authorize': typeof OauthAuthorizeRoute
  '/community/compose': typeof AppCommunityComposeRoute
  '/community/search': typeof AppCommunitySearchRoute
  '/exercises/$id': typeof AppExercisesIdRoute
  '/exercises/new': typeof AppExercisesNewRoute
  '/food/add': typeof AppFoodAddRoute
  '/food/scan': typeof AppFoodScanRoute
  '/food/targets': typeof AppFoodTargetsRoute
  '/food/trends': typeof AppFoodTrendsRoute
  '/routines/new': typeof AppRoutinesNewRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/blocks': typeof AppSettingsBlocksRoute
  '/settings/guide': typeof AppSettingsGuideRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/tokens': typeof AppSettingsTokensRoute
  '/community/': typeof AppCommunityIndexRoute
  '/exercises/': typeof AppExercisesIndexRoute
  '/food/': typeof AppFoodIndexRoute
  '/progress/': typeof AppProgressIndexRoute
  '/routines/': typeof AppRoutinesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/train/': typeof AppTrainIndexRoute
  '/food/foods/$id': typeof AppFoodFoodsIdRoute
  '/food/foods/new': typeof AppFoodFoodsNewRoute
  '/food/recipes/new': typeof AppFoodRecipesNewRoute
  '/progress/exercises/$exerciseId': typeof AppProgressExercisesExerciseIdRoute
  '/routines/$id/edit': typeof AppRoutinesIdEditRoute
  '/routines/templates/$id': typeof AppRoutinesTemplatesIdRoute
  '/train/history/$clientId': typeof AppTrainHistoryClientIdRoute
  '/train/session/$clientId': typeof AppTrainSessionClientIdRoute
  '/train/session/new': typeof AppTrainSessionNewRoute
  '/food/recipes/': typeof AppFoodRecipesIndexRoute
  '/routines/$id/': typeof AppRoutinesIdIndexRoute
  '/train/history/': typeof AppTrainHistoryIndexRoute
  '/community/u/$handle/followers': typeof AppCommunityUHandleFollowersRoute
  '/community/u/$handle/following': typeof AppCommunityUHandleFollowingRoute
  '/food/recipes/$id/edit': typeof AppFoodRecipesIdEditRoute
  '/train/day/$routineId/$dayId': typeof AppTrainDayRoutineIdDayIdRoute
  '/community/u/$handle/': typeof AppCommunityUHandleIndexRoute
  '/food/recipes/$id/': typeof AppFoodRecipesIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/auth/social': typeof AuthSocialRoute
  '/oauth/authorize': typeof OauthAuthorizeRoute
  '/': typeof AppIndexRoute
  '/community/compose': typeof AppCommunityComposeRoute
  '/community/search': typeof AppCommunitySearchRoute
  '/exercises/$id': typeof AppExercisesIdRoute
  '/exercises/new': typeof AppExercisesNewRoute
  '/food/add': typeof AppFoodAddRoute
  '/food/scan': typeof AppFoodScanRoute
  '/food/targets': typeof AppFoodTargetsRoute
  '/food/trends': typeof AppFoodTrendsRoute
  '/routines/new': typeof AppRoutinesNewRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/blocks': typeof AppSettingsBlocksRoute
  '/settings/guide': typeof AppSettingsGuideRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/tokens': typeof AppSettingsTokensRoute
  '/community': typeof AppCommunityIndexRoute
  '/exercises': typeof AppExercisesIndexRoute
  '/food': typeof AppFoodIndexRoute
  '/progress': typeof AppProgressIndexRoute
  '/routines': typeof AppRoutinesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/train': typeof AppTrainIndexRoute
  '/food/foods/$id': typeof AppFoodFoodsIdRoute
  '/food/foods/new': typeof AppFoodFoodsNewRoute
  '/food/recipes/new': typeof AppFoodRecipesNewRoute
  '/progress/exercises/$exerciseId': typeof AppProgressExercisesExerciseIdRoute
  '/routines/$id/edit': typeof AppRoutinesIdEditRoute
  '/routines/templates/$id': typeof AppRoutinesTemplatesIdRoute
  '/train/history/$clientId': typeof AppTrainHistoryClientIdRoute
  '/train/session/$clientId': typeof AppTrainSessionClientIdRoute
  '/train/session/new': typeof AppTrainSessionNewRoute
  '/food/recipes': typeof AppFoodRecipesIndexRoute
  '/routines/$id': typeof AppRoutinesIdIndexRoute
  '/train/history': typeof AppTrainHistoryIndexRoute
  '/community/u/$handle/followers': typeof AppCommunityUHandleFollowersRoute
  '/community/u/$handle/following': typeof AppCommunityUHandleFollowingRoute
  '/food/recipes/$id/edit': typeof AppFoodRecipesIdEditRoute
  '/train/day/$routineId/$dayId': typeof AppTrainDayRoutineIdDayIdRoute
  '/community/u/$handle': typeof AppCommunityUHandleIndexRoute
  '/food/recipes/$id': typeof AppFoodRecipesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/auth/social': typeof AuthSocialRoute
  '/oauth/authorize': typeof OauthAuthorizeRoute
  '/_app/': typeof AppIndexRoute
  '/_app/community/compose': typeof AppCommunityComposeRoute
  '/_app/community/search': typeof AppCommunitySearchRoute
  '/_app/exercises/$id': typeof AppExercisesIdRoute
  '/_app/exercises/new': typeof AppExercisesNewRoute
  '/_app/food/add': typeof AppFoodAddRoute
  '/_app/food/scan': typeof AppFoodScanRoute
  '/_app/food/targets': typeof AppFoodTargetsRoute
  '/_app/food/trends': typeof AppFoodTrendsRoute
  '/_app/routines/new': typeof AppRoutinesNewRoute
  '/_app/settings/account': typeof AppSettingsAccountRoute
  '/_app/settings/blocks': typeof AppSettingsBlocksRoute
  '/_app/settings/guide': typeof AppSettingsGuideRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/tokens': typeof AppSettingsTokensRoute
  '/_app/community/': typeof AppCommunityIndexRoute
  '/_app/exercises/': typeof AppExercisesIndexRoute
  '/_app/food/': typeof AppFoodIndexRoute
  '/_app/progress/': typeof AppProgressIndexRoute
  '/_app/routines/': typeof AppRoutinesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/train/': typeof AppTrainIndexRoute
  '/_app/food/foods/$id': typeof AppFoodFoodsIdRoute
  '/_app/food/foods/new': typeof AppFoodFoodsNewRoute
  '/_app/food/recipes/new': typeof AppFoodRecipesNewRoute
  '/_app/progress/exercises/$exerciseId': typeof AppProgressExercisesExerciseIdRoute
  '/_app/routines/$id/edit': typeof AppRoutinesIdEditRoute
  '/_app/routines/templates/$id': typeof AppRoutinesTemplatesIdRoute
  '/_app/train/history/$clientId': typeof AppTrainHistoryClientIdRoute
  '/_app/train/session/$clientId': typeof AppTrainSessionClientIdRoute
  '/_app/train/session/new': typeof AppTrainSessionNewRoute
  '/_app/food/recipes/': typeof AppFoodRecipesIndexRoute
  '/_app/routines/$id/': typeof AppRoutinesIdIndexRoute
  '/_app/train/history/': typeof AppTrainHistoryIndexRoute
  '/_app/community/u/$handle/followers': typeof AppCommunityUHandleFollowersRoute
  '/_app/community/u/$handle/following': typeof AppCommunityUHandleFollowingRoute
  '/_app/food/recipes/$id/edit': typeof AppFoodRecipesIdEditRoute
  '/_app/train/day/$routineId/$dayId': typeof AppTrainDayRoutineIdDayIdRoute
  '/_app/community/u/$handle/': typeof AppCommunityUHandleIndexRoute
  '/_app/food/recipes/$id/': typeof AppFoodRecipesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/auth/social'
    | '/oauth/authorize'
    | '/community/compose'
    | '/community/search'
    | '/exercises/$id'
    | '/exercises/new'
    | '/food/add'
    | '/food/scan'
    | '/food/targets'
    | '/food/trends'
    | '/routines/new'
    | '/settings/account'
    | '/settings/blocks'
    | '/settings/guide'
    | '/settings/profile'
    | '/settings/tokens'
    | '/community/'
    | '/exercises/'
    | '/food/'
    | '/progress/'
    | '/routines/'
    | '/settings/'
    | '/train/'
    | '/food/foods/$id'
    | '/food/foods/new'
    | '/food/recipes/new'
    | '/progress/exercises/$exerciseId'
    | '/routines/$id/edit'
    | '/routines/templates/$id'
    | '/train/history/$clientId'
    | '/train/session/$clientId'
    | '/train/session/new'
    | '/food/recipes/'
    | '/routines/$id/'
    | '/train/history/'
    | '/community/u/$handle/followers'
    | '/community/u/$handle/following'
    | '/food/recipes/$id/edit'
    | '/train/day/$routineId/$dayId'
    | '/community/u/$handle/'
    | '/food/recipes/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/auth/social'
    | '/oauth/authorize'
    | '/'
    | '/community/compose'
    | '/community/search'
    | '/exercises/$id'
    | '/exercises/new'
    | '/food/add'
    | '/food/scan'
    | '/food/targets'
    | '/food/trends'
    | '/routines/new'
    | '/settings/account'
    | '/settings/blocks'
    | '/settings/guide'
    | '/settings/profile'
    | '/settings/tokens'
    | '/community'
    | '/exercises'
    | '/food'
    | '/progress'
    | '/routines'
    | '/settings'
    | '/train'
    | '/food/foods/$id'
    | '/food/foods/new'
    | '/food/recipes/new'
    | '/progress/exercises/$exerciseId'
    | '/routines/$id/edit'
    | '/routines/templates/$id'
    | '/train/history/$clientId'
    | '/train/session/$clientId'
    | '/train/session/new'
    | '/food/recipes'
    | '/routines/$id'
    | '/train/history'
    | '/community/u/$handle/followers'
    | '/community/u/$handle/following'
    | '/food/recipes/$id/edit'
    | '/train/day/$routineId/$dayId'
    | '/community/u/$handle'
    | '/food/recipes/$id'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/register'
    | '/auth/social'
    | '/oauth/authorize'
    | '/_app/'
    | '/_app/community/compose'
    | '/_app/community/search'
    | '/_app/exercises/$id'
    | '/_app/exercises/new'
    | '/_app/food/add'
    | '/_app/food/scan'
    | '/_app/food/targets'
    | '/_app/food/trends'
    | '/_app/routines/new'
    | '/_app/settings/account'
    | '/_app/settings/blocks'
    | '/_app/settings/guide'
    | '/_app/settings/profile'
    | '/_app/settings/tokens'
    | '/_app/community/'
    | '/_app/exercises/'
    | '/_app/food/'
    | '/_app/progress/'
    | '/_app/routines/'
    | '/_app/settings/'
    | '/_app/train/'
    | '/_app/food/foods/$id'
    | '/_app/food/foods/new'
    | '/_app/food/recipes/new'
    | '/_app/progress/exercises/$exerciseId'
    | '/_app/routines/$id/edit'
    | '/_app/routines/templates/$id'
    | '/_app/train/history/$clientId'
    | '/_app/train/session/$clientId'
    | '/_app/train/session/new'
    | '/_app/food/recipes/'
    | '/_app/routines/$id/'
    | '/_app/train/history/'
    | '/_app/community/u/$handle/followers'
    | '/_app/community/u/$handle/following'
    | '/_app/food/recipes/$id/edit'
    | '/_app/train/day/$routineId/$dayId'
    | '/_app/community/u/$handle/'
    | '/_app/food/recipes/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  AuthSocialRoute: typeof AuthSocialRoute
  OauthAuthorizeRoute: typeof OauthAuthorizeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/social': {
      id: '/auth/social'
      path: '/auth/social'
      fullPath: '/auth/social'
      preLoaderRoute: typeof AuthSocialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/authorize': {
      id: '/oauth/authorize'
      path: '/oauth/authorize'
      fullPath: '/oauth/authorize'
      preLoaderRoute: typeof OauthAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/community/': {
      id: '/_app/community/'
      path: '/community'
      fullPath: '/community/'
      preLoaderRoute: typeof AppCommunityIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/community/compose': {
      id: '/_app/community/compose'
      path: '/community/compose'
      fullPath: '/community/compose'
      preLoaderRoute: typeof AppCommunityComposeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/community/search': {
      id: '/_app/community/search'
      path: '/community/search'
      fullPath: '/community/search'
      preLoaderRoute: typeof AppCommunitySearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercises/': {
      id: '/_app/exercises/'
      path: '/exercises'
      fullPath: '/exercises/'
      preLoaderRoute: typeof AppExercisesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercises/$id': {
      id: '/_app/exercises/$id'
      path: '/exercises/$id'
      fullPath: '/exercises/$id'
      preLoaderRoute: typeof AppExercisesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercises/new': {
      id: '/_app/exercises/new'
      path: '/exercises/new'
      fullPath: '/exercises/new'
      preLoaderRoute: typeof AppExercisesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/': {
      id: '/_app/food/'
      path: '/food'
      fullPath: '/food/'
      preLoaderRoute: typeof AppFoodIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/add': {
      id: '/_app/food/add'
      path: '/food/add'
      fullPath: '/food/add'
      preLoaderRoute: typeof AppFoodAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/scan': {
      id: '/_app/food/scan'
      path: '/food/scan'
      fullPath: '/food/scan'
      preLoaderRoute: typeof AppFoodScanRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/targets': {
      id: '/_app/food/targets'
      path: '/food/targets'
      fullPath: '/food/targets'
      preLoaderRoute: typeof AppFoodTargetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/trends': {
      id: '/_app/food/trends'
      path: '/food/trends'
      fullPath: '/food/trends'
      preLoaderRoute: typeof AppFoodTrendsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/progress/': {
      id: '/_app/progress/'
      path: '/progress'
      fullPath: '/progress/'
      preLoaderRoute: typeof AppProgressIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/routines/': {
      id: '/_app/routines/'
      path: '/routines'
      fullPath: '/routines/'
      preLoaderRoute: typeof AppRoutinesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/routines/new': {
      id: '/_app/routines/new'
      path: '/routines/new'
      fullPath: '/routines/new'
      preLoaderRoute: typeof AppRoutinesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/account': {
      id: '/_app/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AppSettingsAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/blocks': {
      id: '/_app/settings/blocks'
      path: '/settings/blocks'
      fullPath: '/settings/blocks'
      preLoaderRoute: typeof AppSettingsBlocksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/guide': {
      id: '/_app/settings/guide'
      path: '/settings/guide'
      fullPath: '/settings/guide'
      preLoaderRoute: typeof AppSettingsGuideRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/tokens': {
      id: '/_app/settings/tokens'
      path: '/settings/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof AppSettingsTokensRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/train/': {
      id: '/_app/train/'
      path: '/train'
      fullPath: '/train/'
      preLoaderRoute: typeof AppTrainIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/foods/$id': {
      id: '/_app/food/foods/$id'
      path: '/food/foods/$id'
      fullPath: '/food/foods/$id'
      preLoaderRoute: typeof AppFoodFoodsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/foods/new': {
      id: '/_app/food/foods/new'
      path: '/food/foods/new'
      fullPath: '/food/foods/new'
      preLoaderRoute: typeof AppFoodFoodsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/recipes/': {
      id: '/_app/food/recipes/'
      path: '/food/recipes'
      fullPath: '/food/recipes/'
      preLoaderRoute: typeof AppFoodRecipesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/recipes/new': {
      id: '/_app/food/recipes/new'
      path: '/food/recipes/new'
      fullPath: '/food/recipes/new'
      preLoaderRoute: typeof AppFoodRecipesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/progress/exercises/$exerciseId': {
      id: '/_app/progress/exercises/$exerciseId'
      path: '/progress/exercises/$exerciseId'
      fullPath: '/progress/exercises/$exerciseId'
      preLoaderRoute: typeof AppProgressExercisesExerciseIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/routines/$id/': {
      id: '/_app/routines/$id/'
      path: '/routines/$id'
      fullPath: '/routines/$id/'
      preLoaderRoute: typeof AppRoutinesIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/routines/$id/edit': {
      id: '/_app/routines/$id/edit'
      path: '/routines/$id/edit'
      fullPath: '/routines/$id/edit'
      preLoaderRoute: typeof AppRoutinesIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/routines/templates/$id': {
      id: '/_app/routines/templates/$id'
      path: '/routines/templates/$id'
      fullPath: '/routines/templates/$id'
      preLoaderRoute: typeof AppRoutinesTemplatesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/train/history/': {
      id: '/_app/train/history/'
      path: '/train/history'
      fullPath: '/train/history/'
      preLoaderRoute: typeof AppTrainHistoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/train/history/$clientId': {
      id: '/_app/train/history/$clientId'
      path: '/train/history/$clientId'
      fullPath: '/train/history/$clientId'
      preLoaderRoute: typeof AppTrainHistoryClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/train/session/$clientId': {
      id: '/_app/train/session/$clientId'
      path: '/train/session/$clientId'
      fullPath: '/train/session/$clientId'
      preLoaderRoute: typeof AppTrainSessionClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/train/session/new': {
      id: '/_app/train/session/new'
      path: '/train/session/new'
      fullPath: '/train/session/new'
      preLoaderRoute: typeof AppTrainSessionNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/community/u/$handle/': {
      id: '/_app/community/u/$handle/'
      path: '/community/u/$handle'
      fullPath: '/community/u/$handle/'
      preLoaderRoute: typeof AppCommunityUHandleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/community/u/$handle/followers': {
      id: '/_app/community/u/$handle/followers'
      path: '/community/u/$handle/followers'
      fullPath: '/community/u/$handle/followers'
      preLoaderRoute: typeof AppCommunityUHandleFollowersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/community/u/$handle/following': {
      id: '/_app/community/u/$handle/following'
      path: '/community/u/$handle/following'
      fullPath: '/community/u/$handle/following'
      preLoaderRoute: typeof AppCommunityUHandleFollowingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/recipes/$id/': {
      id: '/_app/food/recipes/$id/'
      path: '/food/recipes/$id'
      fullPath: '/food/recipes/$id/'
      preLoaderRoute: typeof AppFoodRecipesIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/food/recipes/$id/edit': {
      id: '/_app/food/recipes/$id/edit'
      path: '/food/recipes/$id/edit'
      fullPath: '/food/recipes/$id/edit'
      preLoaderRoute: typeof AppFoodRecipesIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/train/day/$routineId/$dayId': {
      id: '/_app/train/day/$routineId/$dayId'
      path: '/train/day/$routineId/$dayId'
      fullPath: '/train/day/$routineId/$dayId'
      preLoaderRoute: typeof AppTrainDayRoutineIdDayIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppCommunityComposeRoute: typeof AppCommunityComposeRoute
  AppCommunitySearchRoute: typeof AppCommunitySearchRoute
  AppExercisesIdRoute: typeof AppExercisesIdRoute
  AppExercisesNewRoute: typeof AppExercisesNewRoute
  AppFoodAddRoute: typeof AppFoodAddRoute
  AppFoodScanRoute: typeof AppFoodScanRoute
  AppFoodTargetsRoute: typeof AppFoodTargetsRoute
  AppFoodTrendsRoute: typeof AppFoodTrendsRoute
  AppRoutinesNewRoute: typeof AppRoutinesNewRoute
  AppSettingsAccountRoute: typeof AppSettingsAccountRoute
  AppSettingsBlocksRoute: typeof AppSettingsBlocksRoute
  AppSettingsGuideRoute: typeof AppSettingsGuideRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsTokensRoute: typeof AppSettingsTokensRoute
  AppCommunityIndexRoute: typeof AppCommunityIndexRoute
  AppExercisesIndexRoute: typeof AppExercisesIndexRoute
  AppFoodIndexRoute: typeof AppFoodIndexRoute
  AppProgressIndexRoute: typeof AppProgressIndexRoute
  AppRoutinesIndexRoute: typeof AppRoutinesIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppTrainIndexRoute: typeof AppTrainIndexRoute
  AppFoodFoodsIdRoute: typeof AppFoodFoodsIdRoute
  AppFoodFoodsNewRoute: typeof AppFoodFoodsNewRoute
  AppFoodRecipesNewRoute: typeof AppFoodRecipesNewRoute
  AppProgressExercisesExerciseIdRoute: typeof AppProgressExercisesExerciseIdRoute
  AppRoutinesIdEditRoute: typeof AppRoutinesIdEditRoute
  AppRoutinesTemplatesIdRoute: typeof AppRoutinesTemplatesIdRoute
  AppTrainHistoryClientIdRoute: typeof AppTrainHistoryClientIdRoute
  AppTrainSessionClientIdRoute: typeof AppTrainSessionClientIdRoute
  AppTrainSessionNewRoute: typeof AppTrainSessionNewRoute
  AppFoodRecipesIndexRoute: typeof AppFoodRecipesIndexRoute
  AppRoutinesIdIndexRoute: typeof AppRoutinesIdIndexRoute
  AppTrainHistoryIndexRoute: typeof AppTrainHistoryIndexRoute
  AppCommunityUHandleFollowersRoute: typeof AppCommunityUHandleFollowersRoute
  AppCommunityUHandleFollowingRoute: typeof AppCommunityUHandleFollowingRoute
  AppFoodRecipesIdEditRoute: typeof AppFoodRecipesIdEditRoute
  AppTrainDayRoutineIdDayIdRoute: typeof AppTrainDayRoutineIdDayIdRoute
  AppCommunityUHandleIndexRoute: typeof AppCommunityUHandleIndexRoute
  AppFoodRecipesIdIndexRoute: typeof AppFoodRecipesIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppCommunityComposeRoute: AppCommunityComposeRoute,
  AppCommunitySearchRoute: AppCommunitySearchRoute,
  AppExercisesIdRoute: AppExercisesIdRoute,
  AppExercisesNewRoute: AppExercisesNewRoute,
  AppFoodAddRoute: AppFoodAddRoute,
  AppFoodScanRoute: AppFoodScanRoute,
  AppFoodTargetsRoute: AppFoodTargetsRoute,
  AppFoodTrendsRoute: AppFoodTrendsRoute,
  AppRoutinesNewRoute: AppRoutinesNewRoute,
  AppSettingsAccountRoute: AppSettingsAccountRoute,
  AppSettingsBlocksRoute: AppSettingsBlocksRoute,
  AppSettingsGuideRoute: AppSettingsGuideRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsTokensRoute: AppSettingsTokensRoute,
  AppCommunityIndexRoute: AppCommunityIndexRoute,
  AppExercisesIndexRoute: AppExercisesIndexRoute,
  AppFoodIndexRoute: AppFoodIndexRoute,
  AppProgressIndexRoute: AppProgressIndexRoute,
  AppRoutinesIndexRoute: AppRoutinesIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppTrainIndexRoute: AppTrainIndexRoute,
  AppFoodFoodsIdRoute: AppFoodFoodsIdRoute,
  AppFoodFoodsNewRoute: AppFoodFoodsNewRoute,
  AppFoodRecipesNewRoute: AppFoodRecipesNewRoute,
  AppProgressExercisesExerciseIdRoute: AppProgressExercisesExerciseIdRoute,
  AppRoutinesIdEditRoute: AppRoutinesIdEditRoute,
  AppRoutinesTemplatesIdRoute: AppRoutinesTemplatesIdRoute,
  AppTrainHistoryClientIdRoute: AppTrainHistoryClientIdRoute,
  AppTrainSessionClientIdRoute: AppTrainSessionClientIdRoute,
  AppTrainSessionNewRoute: AppTrainSessionNewRoute,
  AppFoodRecipesIndexRoute: AppFoodRecipesIndexRoute,
  AppRoutinesIdIndexRoute: AppRoutinesIdIndexRoute,
  AppTrainHistoryIndexRoute: AppTrainHistoryIndexRoute,
  AppCommunityUHandleFollowersRoute: AppCommunityUHandleFollowersRoute,
  AppCommunityUHandleFollowingRoute: AppCommunityUHandleFollowingRoute,
  AppFoodRecipesIdEditRoute: AppFoodRecipesIdEditRoute,
  AppTrainDayRoutineIdDayIdRoute: AppTrainDayRoutineIdDayIdRoute,
  AppCommunityUHandleIndexRoute: AppCommunityUHandleIndexRoute,
  AppFoodRecipesIdIndexRoute: AppFoodRecipesIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  AuthSocialRoute: AuthSocialRoute,
  OauthAuthorizeRoute: OauthAuthorizeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
